import { gql } from "@apollo/client";
import { ProjectCardFieldsFragment } from "@govlaunch/project";

export default gql`
  query Government($governmentSlug: String!) {
    government(slug: $governmentSlug) {
      _id
      slug
      name
      logo
      site
      enableSharing
      cover {
        original
        repositioned
      }
      ownerless
      isInnovator
      viewerCanRequestAccess
      viewerRequestedMembership
      viewerRequestedOwnership
      viewerCanInviteMembers
      viewerCanRemoveMembers
      viewerCanSeeTeam
      viewerCanSeeProductStack
      viewerIsMember
      viewerIsOwner
      isFollowing
      budget
      currency
      membersCount
      postsCount
      feedCount
      projectsCount
      storiesCount
      actionsCount
      relatedGovernments {
        _id
        slug
        logo
        name
        city {
          _id
          country
          countryName
        }
      }
      relatedProjects {
        _id
        ...ProjectCardFields
      }
      verifiedProjects {
        items {
          _id
          ...ProjectCardFields
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
      sharing {
        team
        productStack
        projects
        stories
        resources
        awards
      }
      city {
        _id
        name
        stateAbbreviation: state
        state(full: true)
        governmentType
        population
        country
        countryName
        county
        zip
      }
      members {
        _id
        slug
        firstName
        fullName
        jobTitle
        avatar
        isInnovator
      }
      stories {
        items {
          _id
          title
          slug
          verticalCover
          introduction
          viewerCanRead
          viewerIsAuthor
          viewerDidBookmark
          updatedAt
          modifiedAt
          createdAt
          status
          government {
            _id
            slug
            name
            logo
            isInnovator
            city {
              _id
              country
              countryName
            }
          }
        }
      }
      productTags {
        _id
        name
      }

      awards {
        _id
        name
      }

      productsCount
      products {
        _id
        name
        slug
        description
        logo
        isDisruptor

        inViewerStack
        company {
          _id
          name
          slug
        }
      }
      resources {
        ... on LinkResource {
          type
          title
          url
        }
        ... on TextResource {
          type
          title
          body
        }
        ... on DownloadResource {
          type
          title
          url
          filename
        }
      }
      groups {
        _id
        name
        slug

        logo
      }
      settings {
        projectSharingWithGroups {
          _id
          name
          logo
        }
      }
    }
  }

  ${ProjectCardFieldsFragment}
`;
